import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AlertsStateModule } from 'src/app/store/alerts/alerts.state.module';
import { AlertingSettingsPageComponent } from './alerting.component';
import { AlertConfigurationWizardComponent } from './pages/components/configuration-wizard/configuration-wizard.component';
import { AlertProcessorSimulationResultViewerComponent } from './pages/components/simulation-result-viewer/result-viewer.component';
import { CreateAlertProcessorPageComponent } from './pages/create-processor/create.component';
import { CreateAlertSourcePageComponent } from './pages/create-source/create.component';
import { AlertProcessorDetailsSettingsPageComponent } from './pages/details-processor/details.component';
import { AlertSourcesDetailsSettingsPageComponent } from './pages/details-source/details.component';
import { AlertingOverviewSettingsPageComponent } from './pages/overview/overview.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: '',
    },
    component: AlertingOverviewSettingsPageComponent,
  },
  {
    path: 'sources/new',
    data: {
      title: 'pages.settings.alerting.sources.create.title',
    },
    component: CreateAlertSourcePageComponent,
  },
  {
    path: 'processors/new',
    data: {
      title: 'pages.settings.alerting.processors.create.title',
    },
    component: CreateAlertProcessorPageComponent,
  },
  {
    path: 'sources/:id',
    data: {
      dynamicTitle: true,
    },
    component: AlertSourcesDetailsSettingsPageComponent,
  },
  {
    path: 'processors/:id',
    data: {
      dynamicTitle: true,
    },
    component: AlertProcessorDetailsSettingsPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    AlertsStateModule,
    AlertConfigurationWizardComponent,
    AlertProcessorSimulationResultViewerComponent,
    AlertingOverviewSettingsPageComponent,
    AlertingSettingsPageComponent,
    AlertProcessorDetailsSettingsPageComponent,
    CreateAlertProcessorPageComponent,
    CreateAlertSourcePageComponent,
    AlertSourcesDetailsSettingsPageComponent,
  ],
  providers: [],
  bootstrap: [],
  exports: [RouterModule],
})
export class AlertingSettingsModule {}
